import type { CorvidSDKFactory } from '@wix/editor-elements-types/corvid';

type CreateA11ySdkFactory = ({
  a11yProperty,
}: {
  a11yProperty: string;
}) => CorvidSDKFactory;

export const createA11ySdk: CreateA11ySdkFactory =
  ({ a11yProperty }) =>
  api => {
    const { props, setProps } = api;
    return {
      accessibility: {
        get ariaLabel() {
          return props[a11yProperty]?.ariaLabel;
        },
        set ariaLabel(value: string) {
          const existingA11y = props[a11yProperty] ?? {};
          setProps({ [a11yProperty]: { ...existingA11y, ariaLabel: value } });
        },
      },
    };
  };
